module.exports = __webpack_public_path__ + "423a461b1d7167e77cdae2d833fcd2dd.svg";